<template>
  <div :class="`container legal-container-${theme}`">
    <wrap-container class="w100">
      <p class="title" aria-level="1">Aviso legal</p>
      <footer>
        <slot>
          <p
            class="legal-text p14 book"
            v-safe-html="text"
            ref="termsContent"
          ></p>
        </slot>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer },
  props: {
    text: String,
    hasFixedButton: Boolean,
    theme: {
      type: String,
      default: "dark"
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  margin: 16px 0 40px 0;
}

.title::before {
  content: url("../../assets/img/1x/activities-bullet.svg");
  padding-right: 14px;
}

.legal-text {
  font:
    350 15px/24px "BentonSansBBVA-Book",
    Helvetica,
    Arial,
    sans-serif;
}

div.container {
  font-size: 12px;
  line-height: 1.5em;
  padding: 32px 17px !important;
  text-align: justify;
  margin-bottom: 0px;
}

/* themes */
div.legal-container-light .title {
  color: #000000;
}

div.legal-container-dark .title {
  color: #e4e4e4;
}

div.legal-container-dark {
  background: #072146;
  color: #e4e4e4;
}

div.legal-container-light {
  background: #e9e9e9;
  color: #000000;
}

img {
  display: block;
  width: 112px;
  height: auto;
  margin-top: 16px;
}

div.container-fixed-button {
  padding-bottom: 90px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 1024px) {
  div.legal-container-light .title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
}
</style>
